import { Pocket } from '../../../utils/dexie/db'
import { handleDecryptMessage, handleEncryptMessage } from '../../../utils'

export const handleEncryptPocketData = async (pocketDataToEncrypt: Pocket, secret: string) => {
  return {
    main: pocketDataToEncrypt.main,
    synced: pocketDataToEncrypt.synced,
    id: String(pocketDataToEncrypt.id),
    deleted: pocketDataToEncrypt.deleted,
    createdAt: new Date(pocketDataToEncrypt.createdAt).getTime(),
    updatedAt: new Date(pocketDataToEncrypt.updatedAt).getTime(),
    fundsTransferedTo: String(pocketDataToEncrypt.fundsTransferedTo),
    name: await handleEncryptMessage(String(pocketDataToEncrypt.name), secret),
    balance: await handleEncryptMessage(String(pocketDataToEncrypt.balance), secret),
    belongsTo: await handleEncryptMessage(String(pocketDataToEncrypt.belongsTo), secret),
    balanceToBeDebited: await handleEncryptMessage(String(pocketDataToEncrypt.balanceToBeDebited), secret),
    balanceToBeCredited: await handleEncryptMessage(String(pocketDataToEncrypt.balanceToBeCredited), secret)
  }
}

export const handleDecryptPocketData = async (pocketDataToDecrypt: Pocket, secret: string) => {
  return {
    id: pocketDataToDecrypt.id,
    main: pocketDataToDecrypt.main,
    synced: pocketDataToDecrypt.synced,
    deleted: pocketDataToDecrypt.deleted,
    createdAt: pocketDataToDecrypt.createdAt,
    updatedAt: pocketDataToDecrypt.updatedAt,
    fundsTransferedTo: String(pocketDataToDecrypt.fundsTransferedTo),
    name: await handleDecryptMessage(String(pocketDataToDecrypt.name), secret),
    belongsTo: await handleDecryptMessage(String(pocketDataToDecrypt.belongsTo), secret),
    balance: Number(await handleDecryptMessage(String(pocketDataToDecrypt.balance), secret)),
    balanceToBeDebited: Number(await handleDecryptMessage(String(pocketDataToDecrypt.balanceToBeDebited), secret)),
    balanceToBeCredited: Number(await handleDecryptMessage(String(pocketDataToDecrypt.balanceToBeCredited), secret))
  }
}

export const handleDecryptPocketsData = async (pocketsDataEncrypted: Array<Pocket>, secret: string) => {
  const pocketsDataDecrypted = []

  for (const pocketDataEncrypted of pocketsDataEncrypted) {
    const pocketDataDecrypted = await handleDecryptPocketData(pocketDataEncrypted, String(secret))
    pocketsDataDecrypted.push(pocketDataDecrypted)
  }

  return pocketsDataDecrypted
}
